import React from "react";
import { Routes, Route } from "react-router-dom";
import { Indicadores, Indicador } from "../../../pagesPublic";

const IndicadoresRoutes = () => {
  return (
    <Routes>
      <Route exact path={`:id/*`} element={<Indicador />} />
      <Route path={"*"} element={<Indicadores />} />
    </Routes>
  );
};

export default IndicadoresRoutes;
